var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-overlay',{staticClass:"text-center"},[_c('v-img',{attrs:{"src":require("../../assets/logos/iturnier-squared.png"),"max-width":_vm.$vuetify.breakpoint.mdAndUp ? '10vw' : '25vw'}}),_c('br'),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }